import styled from "styled-components"

export const Container = styled.div`
    padding: 20px;
    margin-bottom: 200px;
    background-color: #f8fafc;
    min-height: 100vh;
`

// 검색/필터를 상단에 고정. 스크롤 중에도 항상 거를 수 있게 함.
export const StickyArea = styled.div`
    position: sticky;
    top: 0;
    z-index: 30;
    /* 컨테이너 좌우 padding(20px)을 상쇄해 화면 끝까지 배경이 차도록 */
    margin: 0 -20px;
    padding: 8px 20px 10px;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);

    .head {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;

        .searchToggle {
            height: 36px;
            padding: 0 12px;
            border: 1px solid #cbd5e0;
            background: #fff;
            border-radius: 8px;
            font-size: 13px;
            font-weight: 700;
            color: #334155;
            cursor: pointer;

            &:active {
                background: #edf2f7;
            }
        }

        .count {
            font-size: 13px;
            font-weight: 700;
            color: #4a5568;
        }

        .typeChip {
            padding: 4px 10px;
            border-radius: 6px;
            cursor: pointer;
            font-size: 12px;
            font-weight: 600;
        }

        .expandButtons {
            margin-left: auto;
            display: flex;
            gap: 6px;

            button {
                height: 34px;
                padding: 0 10px;
                border: 1px solid #cbd5e0;
                border-radius: 8px;
                background: #fff;
                font-size: 12px;
                font-weight: 600;
                color: #4a5568;
                cursor: pointer;

                &:active {
                    background: #edf2f7;
                }
            }
        }
    }
`

export const TopButtons = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
    
    button {
        width: 120px;
        background: #3b82f6;
        color: #fff;
        border: none;
        border-radius: 8px;
        padding: 10px 16px;
        font-weight: 600;
        transition: all 0.2s;
        
        &:hover {
            background: #2563eb;
            transform: translateY(-2px);
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        
        &:active {
            transform: translateY(0);
        }
    }
`

// LocationCount.Container 스타일을 모바일 환경에 맞게 수정합니다.
export const LocationCount = {
  Container: styled.div`
        margin-top: 20px;
        font-size: 14px;
        background: white;
        padding: 16px;
        border-radius: 12px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: column;
        gap: 12px;
        
        @media (min-width: 768px) {
            flex-direction: row;
            justify-content: space-between;
        }
        
        .flex {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
            
            @media (max-width: 767px) {
                flex-direction: column;
                gap: 8px;
            }
        }
        
        span {
            font-weight: 600;
            display: inline-block;
            min-width: 80px;
        }
        
        div {
            white-space: nowrap;
        }
    `,
}

export const EventField = {
  Container: styled.div`
        margin-top: 20px;
        background: white;
        padding: 16px;
        border-radius: 12px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    `,
  SelectedLocations: styled.div`
        .label {
            font-weight: 600;
            font-size: 15px;
            color: #334155;
            margin-bottom: 8px;
        }
        .list {
            margin-top: 10px;
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            .item {
                user-select: none;
                border: none;
                font-size: 13px;
                background: #eff6ff;
                color: #2563eb;
                font-weight: 600;
                padding: 6px 12px;
                border-radius: 50px;
                cursor: pointer;
                transition: all 0.2s;
                
                &:hover {
                    background: #dbeafe;
                    transform: translateY(-1px);
                }
                
                &:active {
                    transform: translateY(0);
                }
            }
        }
    `,
  Buttons: styled.div`
        margin-top: 20px;
        button {
            width: auto;
            height: 40px;
            background: #3b82f6;
            color: #fff;
            border: none;
            padding: 10px 16px;
            border-radius: 8px;
            font-weight: 600;
            transition: all 0.2s;
            
            &:hover {
                background: #2563eb;
                transform: translateY(-2px);
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            }
            
            &:active {
                transform: translateY(0);
            }
        }
    `,
}

export const CreateRackLocationModal = {
  HeaderContainer: styled.div`
        padding: 10px;
        position: sticky;
        top: 0;
        background: #ffffff;
        z-index: 10;
        border-bottom: 1px solid #e2e8f0;
    `,
  AddConditionsContainer: styled.div`
        padding: 16px;
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        background: #f8fafc;
        border-radius: 8px;

        .inputBox {
            width: 100%;
        }

        button {
            width: 100%;
            height: 50px;
            background: #3b82f6;
            color: white;
            border: none;
            border-radius: 8px;
            font-weight: 600;
            transition: all 0.2s;
            
            &:hover {
                background: #2563eb;
            }
        }
    `,
  RackLocationsContainer: styled.div`
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        max-height: 400px;
        overflow-y: auto;

        .itemBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border: 1px solid #e2e8f0;
            padding: 12px 16px;
            border-radius: 10px;
            background: white;
            transition: all 0.2s;
            
            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
            }
            
            .address {
                font-weight: 600;
                font-size: 14px;
            }

            .type {
                width: 150px;
                border-radius: 8px;
                font-weight: 600;

                &.normal {
                    color: #16a34a;
                    border-color: #16a34a;
                    background: #f0fdf4;
                }

                &.inventory {
                    color: #2563eb;
                    border-color: #2563eb;
                    background: #eff6ff;
                }
            }
        }
    `,
  SaveContainer: styled.div`
        position: sticky;
        bottom: 0;
        background: white;
        padding: 16px;
        border-top: 1px solid #e2e8f0;
        
        button {
            width: 100%;
            padding: 12px;
            background: #3b82f6;
            color: white;
            border: none;
            border-radius: 8px;
            font-weight: 600;
            transition: all 0.2s;
            
            &:hover {
                background: #2563eb;
            }
        }
    `,
}
